(function () {
  if (window.__lhdAtcBar) return;
  window.__lhdAtcBar = true;

  var MQ = window.matchMedia('(max-width: 768.98px) and (orientation: portrait)');
  var PAD = 10;         // vertical padding of the floating bar - keep in sync with the CSS
  var MAX_ROW_H = 120;  // a taller row means something extra got injected into it
  var CHAT_GAP = 12;
  var root = document.documentElement;

  var row = null, spacer = null, rowObserver = null, chatEl = null, chatOrig = null;
  var naturalH = 0, floating = false, tooTall = false, broken = false, ticking = false;

  function measure() {
    if (floating || !row) return;
    naturalH = row.getBoundingClientRect().height;
    tooTall = naturalH > MAX_ROW_H;
  }

  function attach() {
    var r = document.querySelector('.js-product-form-main .product-info__add-to-cart');
    if (!r) return false;
    if (r === row && row.isConnected) return true;

    // first run, or the theme re-rendered the form: start clean
    if (rowObserver) rowObserver.disconnect();
    if (spacer && spacer.parentNode) spacer.parentNode.removeChild(spacer);
    floating = false;
    root.classList.remove('lhd-atc-floating');

    row = r;
    spacer = document.createElement('div');
    spacer.className = 'lhd-atc-spacer';
    spacer.setAttribute('aria-hidden', 'true');
    row.parentNode.insertBefore(spacer, row);
    measure();

    if ('MutationObserver' in window) {
      rowObserver = new MutationObserver(onRowChange);
      rowObserver.observe(row, { childList: true, subtree: true });
    }
    return true;
  }

  // ---- Freshchat: lift it above the bar only while the bar is floating ----
  function applyChat() {
    if (!chatEl) return;
    if (!chatOrig) {
      chatOrig = {
        bottom: chatEl.style.getPropertyValue('bottom'), bottomP: chatEl.style.getPropertyPriority('bottom'),
        top: chatEl.style.getPropertyValue('top'), topP: chatEl.style.getPropertyPriority('top')
      };
    }
    if (floating) {
      var b = (naturalH + PAD * 2 + CHAT_GAP) + 'px';
      if (chatEl.style.getPropertyValue('bottom') !== b || chatEl.style.getPropertyPriority('bottom') !== 'important') {
        chatEl.style.setProperty('bottom', b, 'important');
        chatEl.style.setProperty('top', 'auto', 'important');
      }
    } else if (chatEl.style.getPropertyPriority('bottom') === 'important' && chatEl.style.getPropertyValue('bottom') !== chatOrig.bottom) {
      if (chatOrig.bottom) chatEl.style.setProperty('bottom', chatOrig.bottom, chatOrig.bottomP); else chatEl.style.removeProperty('bottom');
      if (chatOrig.top) chatEl.style.setProperty('top', chatOrig.top, chatOrig.topP); else chatEl.style.removeProperty('top');
    }
  }

  function watchChat(el) {
    chatEl = el;
    applyChat();
    if ('MutationObserver' in window) {
      new MutationObserver(function () { if (floating) applyChat(); })
        .observe(el, { attributes: true, attributeFilter: ['style', 'class'] });
    }
  }

  // ---- floating state ----
  function sanityCheck() {
    if (!floating) return;
    var r = row.getBoundingClientRect();
    // not where a fixed, bottom-pinned bar should be (e.g. a transformed ancestor
    // is acting as its containing block) - give up for this page view
    if (r.bottom > window.innerHeight + 40 || r.top < 0 || r.height - PAD * 2 > MAX_ROW_H) {
      broken = true;
      setFloating(false);
    }
  }

  function setFloating(next) {
    if (next === floating) return;
    floating = next;
    row.classList.toggle('lhd-atc-bar--fixed', next);
    spacer.style.height = next ? naturalH + 'px' : '0px';
    root.classList.toggle('lhd-atc-floating', next);
    root.style.setProperty('--lhd-atc-h', (naturalH + PAD * 2) + 'px');
    applyChat();
    if (next) window.requestAnimationFrame(sanityCheck);
  }

  function update() {
    ticking = false;
    if (!attach()) return;
    if (!MQ.matches || broken || tooTall || naturalH < 20) { setFloating(false); return; }
    // float while the row's normal spot is still below where the bar would sit
    var top = spacer.getBoundingClientRect().top;
    setFloating(top > window.innerHeight - PAD - naturalH);
  }

  function request() {
    if (!ticking) { ticking = true; window.requestAnimationFrame(update); }
  }

  function remeasure() {
    if (!attach()) return;
    setFloating(false);
    measure();
    update();
  }

  function onRowChange() { remeasure(); }

  window.addEventListener('scroll', request, { passive: true });
  window.addEventListener('resize', remeasure);
  window.addEventListener('orientationchange', remeasure);
  window.addEventListener('load', remeasure);
  update();

  // Freshchat loads late and lives in a cross-origin iframe - we can only move
  // the iframe element itself (#fc_frame), not anything inside it.
  var tries = 0;
  var timer = setInterval(function () {
    tries += 1;
    var el = document.getElementById('fc_frame');
    if (el) { watchChat(el); clearInterval(timer); }
    else if (tries >= 40) clearInterval(timer);
  }, 200);
})();